exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-button[data-v-6eb06ba2] {\n    position: relative;\n    top: -3px;\n}\n.instructions[data-v-6eb06ba2] {\n    line-height: 1.2em;\n    font-size: .90em;\n    font-style: italic;\n}\n", ""]);

// exports
